import { render } from "./LoginForgot.vue?vue&type=template&id=b6830898&scoped=true&ts=true"
import script from "./LoginForgot.vue?vue&type=script&lang=ts"
export * from "./LoginForgot.vue?vue&type=script&lang=ts"

import "./LoginForgot.vue?vue&type=style&index=0&id=b6830898&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6830898"]])

export default __exports__